const APP_VERSION = '2.0.0';
const APP_BUILD_DATE = '20/11/2025';
const roles = {
  ADMIN: 1,
  TEAMMEMBER: 2,
};
const defaultPassword = 'Nomadic1234@';
const eventType = {
  registerClinic: 'REGISTER_CLINIC',
  registerPatient: 'REGISTER_PATIENT',
  registerMember: 'REGISTER_MEMBER',
  careBuddyAccountCreated: 'CARE_BUDDY_ACCOUNT_CREATED',
  careBuddyLinkedToPatient: 'CARE_BUDDY_LINKED_TO_PATIENT',
  careBuddyRemoved: 'CARE_BUDDY_REMOVED',
  careBuddyCompletedFollowUp: 'CARE_BUDDY_COMPLETED_FOLLOW_UP',
  careBuddyCompletedReferral: 'CARE_BUDDY_COMPLETED_REFERRAL',
  careBuddyViewedDocument: 'CARE_BUDDY_VIEWED_DOCUMENT',
  careBuddyUnauthorizedAttempt: 'CARE_BUDDY_UNAUTHORIZED_ATTEMPT',
  addCondition: 'ADD_CONDITION',
  addTask: 'ADD_TASK',
  editTask: 'EDIT_TASK',
  addAdminAuthQR: 'ADD_ADMIN_AUTH_QR',
  editClinic: 'EDIT_CLINIC',
  editUser: 'EDIT_USER',
  changeAdmin: 'CHANGE_ADMIN',
  editPatient: 'EDIT_PATIENT',
  addDocument: 'ADD_DOCUMENT',
  deleteMember: 'DELETE_MEMBER',
  removeContributor: 'REMOVE_CONTRIBUTOR',
  changeSubscription: 'CHANGE_SUBSCRIPTION_PLAN',
  updateTeamMemberInformation: 'UPDATE_TEAM_MEMBER_INFORMATION',
  addHealthNotes: 'ADD_HEALTH_NOTES',
  editHealthNotes: 'EDIT_HEALTH_NOTES',
  updateDocumentStatus: 'UPDATE_DOCUMENT_STATUS',
  completeCondition: 'COMPLETE_CONDITION',
  updateCondition: 'UPDATE_CONDITION',
  changeTaskStatus: 'CHNAGE_TASK_STATUS',
  addClinicToPatient: 'ADD_CLINIC_TO_PATIENT',
  editTask: 'EDIT_TASK',
  changeCoordinator: 'CHNAGE_CORDINATOR',
  addTeamMember: 'ADD_TEAM_MEMBER',
  addRecurringTaskEvent: 'ADD_RECURRING_EVENT',
};
const DATE_PICKER_DATE_FORMAT = 'MM-dd-yyyy';
const DATE_PICKER_DATE_FORMAT_NEW = 'dd-MM-yyyy';
const DATE_FORMAT = 'MM-DD-YYYY';
const DATE_FORMAT_NEW = 'DD-MM-YYYY';
const DATE_PICKER_TIME_FORMAT = 'HH:mm';
const DURATION_TIME_FORMAT = 'Do MMM YYYY';
const DATE_FORMAT_VIEW = 'Do MMM YYYY';

const sex = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
];
const indigenousStatus = [
  { value: 'nil', label: 'Not Applicable' },
  { value: 'toresStraightIslander', label: 'Torres Strait Islander' },
  { value: 'aboriginal', label: 'Aboriginal' },
];

const indentificationType = [
  {
    value: 'medicareNumber',
    label: 'Medicare Number',
  },
  {
    value: 'driverLicenseNo',
    label: 'Driver License No',
  },
  {
    value: 'passport',
    label: 'Passport',
  },
];

const DOCUMENT_EDITING_ALLOWED_FILE_EXTENTIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'rtf'];

const idChar = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const codeChar = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const yearDropdownItemNumber = 10;
const modalEffect = 'fadeInDown';
const templateTaskLockedTooltip =
  "This field was set by administration in the template and can’t be changed.";

const status = {
  active: {
    name: 'active',
    displayName: 'Active',
  },
  inactive: {
    name: 'inactive',
    displayName: 'Inactive',
  },
};

const documentType = {
  education: 'education',
  prescription: 'prescription',
};

const taskState = {
  accepted: {
    name: 'accepted',
    displayName: 'Accepted',
  },
  declined: {
    name: 'declined',
    displayName: 'Declined',
  },
  pending: {
    name: 'pending',
    displayName: 'Pending',
  },
};

const appointmentType = {
  teleHealth: {
    name: 'teleHealth',
    displayName: 'Telehealth',
  },
  inClinic: {
    name: 'inClinic',
    displayName: 'In Clinic',
  },
};

const appointmentStatus = {
  scheduled: { name: 'scheduled', displayName: 'Scheduled' },
  cancelled: { name: 'cancelled', displayName: 'Cancelled' },
  completed: { name: 'completed', displayName: 'Completed' },
  noShow: { name: 'noShow', displayName: 'No Show' },
};

const timeFrame = [
  { value: 'before', label: 'Before' },
  { value: 'on', label: 'On' },
  { value: 'after', label: 'After' },
];

const taskTypes = {
  readDocument: 'readDocument',
  treatment: 'treatment',
  medication: 'medication',
  trackProgress: 'trackProgress',
  takeTest: 'takeTest',
  referral: 'referral',
  completeForm: 'completeForm',
  followUp: 'followUp',
};

const taskTypesOptions =[
  { value: 'readDocument', label: 'Read Document' },
  { value: 'treatment', label: 'Treatment' },
  { value: 'medication', label: 'Medication' },
  { value: 'trackProgress', label: 'Track Progress' },
  { value: 'takeTest', label: 'Take Test' },
  { value: 'referral', label: 'Referral' },
  { value: 'completeForm', label: 'Complete Form' },
  { value: 'followUp', label: 'Follow Up' },
];

const TASK_TYPE_HELP = {
  bookAppointment: 'Book an appointment task for Follow Up or Referral. Choose Follow Up for recurring check-ins or Referral to connect the patient with another clinician.',
  takeTest: 'Assign the patient to take a test (e.g. blood test, imaging). You can attach forms and set due dates.',
  trackProgress: 'Track health measurements over time such as weight, blood pressure, steps, or pain levels. Configure alerts and goals.',
  medication: 'Add medication instructions, dosage, frequency, and duration for the patient.',
  treatment: 'Add treatment tasks such as physiotherapy or other allied health sessions with scheduling.',
  readDocument: 'Assign the patient to read or view a document. Useful for education materials or consent forms.',
  completeForm: 'Provider-only task. Assign a clinician to complete a form. No patient action or booking required. Daily email reminders sent to the assigned provider after the due date until completed.',
};

const providerTypes = [
  'AHPRA',
  'HICAPS',
  'MPN'
];

// let firebaseFunctionsUrl =
//   'https://australia-southeast1-nc-events-uat2.cloudfunctions.net/' //UAT

// let firebaseFunctionsUrl =
//   'http://127.0.0.1:5002/nc-events-prod3/australia-southeast1/'

let firebaseFunctionsUrl = 'https://australia-southeast1-nc-events-uatlf-2024-10-e135d.cloudfunctions.net/' //UATLF
// firebaseFunctionsUrl = 'http://127.0.0.1:5002/nc-events-uatlf-2024-10-e135d/australia-southeast1/'

console.log(process.env.REACT_APP_HOST_ENV);
if (process.env.REACT_APP_HOST_ENV === 'production') {
  firebaseFunctionsUrl = 'https://australia-southeast1-nc-events-prod3.cloudfunctions.net/'; //Production
  // firebaseFunctionsUrl = 'http://127.0.0.1:5002/nc-events-prod3/australia-southeast1/';
}

// Provider Directory marketplace iframe base URL (admin-only visibility of embed tokens).
let marketplaceBaseUrl = 'https://marketplace.nomadiccare.com.au';
if (process.env.REACT_APP_HOST_ENV === 'production') {
  marketplaceBaseUrl = 'https://marketplace.nomadiccare.com.au';
}

// reCAPTCHA v3 site key — public, safe to hardcode (it is not a secret).
let RECAPTCHA_SITE_KEY = '6LccU_gsAAAAAKWEfqa1vH989elU4JpQYNhKcK-J';
if (process.env.REACT_APP_HOST_ENV === 'production') {
  RECAPTCHA_SITE_KEY = '6LeKVfgsAAAAAKWvl5dDpqjIhXRG2obziK3NA6h2';
}
// Embeddable Provider Directory iframe base URL (token-only identifier; no clinicId in URL).
let directoryEmbedBaseUrl = 'https://uatlf.nomadiccare.com.au/provider-directory/embed/';
if (process.env.REACT_APP_HOST_ENV === 'production') {
  directoryEmbedBaseUrl = 'https://app.nomadiccare.com.au/provider-directory/embed/';
}

const followUpList = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];
const followUpTimeFrameList = [
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
];
const meetingTypeList = [
  {
    value: 'inClinic',
    label: 'In Clinic',
  },
  {
    value: 'teleHealth',
    label: 'Telehealth',
    // disabled: true
  },
];

const periodList = [
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
  { value: 'year', label: 'Year' },
];

const frequencyPeriodList = [
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
  { value: 'halfYear', label: '6 Months' },
];
const bpFrequencyList = [
  { value: 'once', label: 'Once per Day' },
  { value: 'twice', label: 'Twice per Day' },
  { value: 'custom', label: 'Custom' },
];
const sensitibityList = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];

const trackingTypes = {
  bodyWeight: 'bodyWeight',
  bmi: 'bmi',
  painLevel: 'painLevel',
  stepCount: 'stepCount',
  bloodPressure: 'bloodPressure',
  bloodGlucose: 'bloodGlucose',
  caloricIntake: 'caloricIntake',
  temperature: 'temperature',
  sleep: 'sleep',
  fallPrevention: 'fallPrevention',
  selfReport: 'selfReport',
};

const trackingTypeList = [
  { value: 'bodyWeight', label: 'Body Weight' },
  { value: 'bmi', label: 'BMI' },
  { value: 'stepCount', label: 'Step Count' },
  { value: 'bloodPressure', label: 'Blood Pressure' },
  { value: 'bloodGlucose', label: 'Blood Glucose' },
  { value: 'caloricIntake', label: 'Calorie Intake' },
  { value: 'temperature', label: 'Temperature' },
  { value: 'sleep', label: 'Sleep' },
  { value: 'fallPrevention', label: 'Fall Prevention' },
  { value: 'selfReport', label: 'Self-report' },
];

// Legacy lookup list — includes removed types so existing saved tasks still resolve their label
const trackingTypeListAll = [
  ...trackingTypeList,
  { value: 'painLevel', label: 'Pain Levels' },
];

const measurementScaleList = [
  { value: 'likertScale', label: 'Likert Scale' },
  { value: 'frequency', label: 'Frequency' },
  { value: 'numeric', label: 'Numeric' },
];

const selfReportHelperText = {
  likertScale: { line1: 'How the patient will respond:', line2: 'Very low · Low · Mild · Moderate · High · Very high' },
  frequency: { line1: 'How the patient will respond:', line2: 'Never · Rarely · Sometimes · Often · Very often · Always' },
  numeric: { line1: 'How the patient will respond:', line2: '(Lowest) 0 · 1 · 2 · 3 · 4 · 5 (Highest)' },
};

const selfReportAlertOptions = {
  likertScale: [
    { value: 'veryLow', label: 'Very low' },
    { value: 'low', label: 'Low' },
    { value: 'mild', label: 'Mild' },
    { value: 'moderate', label: 'Moderate' },
    { value: 'high', label: 'High' },
    { value: 'veryHigh', label: 'Very high' },
  ],
  frequency: [
    { value: 'never', label: 'Never' },
    { value: 'rarely', label: 'Rarely' },
    { value: 'sometimes', label: 'Sometimes' },
    { value: 'often', label: 'Often' },
    { value: 'veryOften', label: 'Very often' },
    { value: 'always', label: 'Always' },
  ],
};

const ranges = [
  // { label: 'Last Week', value: 'last_week' },
  { label: 'Last Month', value: 'last_month' },
  { label: 'Last 6 Months', value: 'last_6_months' },
  { label: 'Last Year', value: 'last_year' },
];

const measurements = {
  bodyWeight: [
    { value: 'kg', label: 'KG' },
    { value: 'lb', label: 'LB' },
  ],
  bmi: [
    { value: 'lbs/inches2', label: 'lbs/inches2' },
    { value: 'kg/m2', label: 'kg/m2' },
  ],
  painLevel: [
    { value: '0', label: '0' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
    { value: '7', label: '7' },
    { value: '8', label: '8' },
    { value: '9', label: '9' },
    { value: '10', label: '10' },
  ],
  stepCount: [{ value: 'steps', label: 'Steps' }],
  bloodPressure: [{ value: 'mmHg', label: 'mmHg (millimetres of mercury)' }],
  bloodGlucose: [{ value: 'mmol/L', label: 'mmol/L (millimoles per litre)' }],
  caloricIntake: [
    { value: 'calories', label: 'Calories' },
    { value: 'kJ', label: 'kJ (kilojoules)' },
  ],
  temperature: [
    { value: 'celcius', label: 'Celcius' },
    { value: 'fahrenheit', label: 'Fahrenheit' },
  ],
  sleep: [
    { value: 'hours', label: 'Hours of sleep' },
    { value: 'rem', label: 'REM (rapid eye movement)' },
    { value: 'nrem', label: 'NREM (non rapid eye movement)' },
  ],
};

const alertForList = [
  { value: 'lessThan', label: 'Less Than' },
  { value: 'moreThan', label: 'More Than' },
  { value: 'average', label: 'Average (Mean)' },
];

const conditionExist = 'This Condition already exists for this patient!';

const teamMemberType = {
  coordinator: {
    name: 'coordinator',
    displayName: 'Coordinator',
  },
  contributor: {
    name: 'contributor',
    displayName: 'Contributor',
  },
};

const teamStatus = {
  activated: {
    name: 'activated',
    displayName: 'Activate',
  },
  deactivated: {
    name: 'deactivated',
    displayName: 'Deactivate',
  },
  pending: {
    name: 'pending',
    displayName: 'Pending',
  },
};

const alertCount = 3;

const subscriptionPlan = {
  free: {
    name: 'free',
    displayName: 'Free',
    patientCount: 3,
    clinicianCount: 1,
  },
  basic: {
    name: 'basic',
    displayName: 'Basic',
    patientCount: 'unlimited',
    clinicianCount: 7,
  },
  premium: {
    name: 'premium',
    displayName: 'Premium',
    patientCount: 'unlimited',
    clinicianCount: 20,
  },
};

const localUrl = `${window.location.origin}/`;
// const serverUrl = "https://nomadic-care-26ff8.web.app/";

const ALGOLIA_APPID = '1BOVJO2NAI';
const ALGOLIA_ADMIN_KEY = 'c8ff4576c0605a3c8f3ec8cb8bcde0a9';
const ALGOLIA_SEARCH_KEY = 'f974dad7fe7ec148bc08ce302b1d88a6';

const uploadedByType = {
  patients: 'patients',
  users: 'users',
};

const mediaType = {
  image: 'image',
  video: 'video',
};

const shortDateFormat = 'DD MMM YYYY';

const clinicianType = {
  externalDoctor: 'externalDoctor',
  internalDoctor: 'internalDoctor',
};

const medicationRoutesList = [
  {
    value: 'oral',
    label: 'Oral',
  },
  {
    value: 'nasalMucosa',
    label: 'Nasal mucosa (nose)',
  },
  {
    value: 'oralMucosa',
    label: 'Oral mucosa (mouth)',
  },
  {
    value: 'lip',
    label: 'Lip',
  },
  {
    value: 'ear',
    label: 'Ear',
  },
  {
    value: 'vaginal',
    label: 'Vaginal',
  },
  {
    value: 'rectal',
    label: 'Rectal',
  },
  {
    value: 'topical',
    label: 'Topical',
  },
  {
    value: 'intravenousInjection',
    label: 'Intravenous injection',
  },
  {
    value: 'intramuscularInjection',
    label: 'Intramuscular injection',
  },
  {
    value: 'subcutaneousInjection',
    label: 'Subcutaneous injection',
  },
];

const medicationUnitList = [
  {
    value: 'mg',
    label: 'Mg',
  },
  {
    value: 'g',
    label: 'G',
  },
  {
    value: 'tabletsCapsules',
    label: 'Tablets / Capsules',
    single: 'Tablet / Capsule',
  },
  {
    value: 'microGrams',
    label: 'Micro Grams',
    single: 'Micro Gram',
  },
];

const timeUnit = [
  { value: 'days', label: 'Day' },
  { value: 'weeks', label: 'Week' },
  { value: 'months', label: 'Month' },
  { value: 'year', label: 'Year' }
];
export default {
  eventType,
  defaultPassword,
  DATE_PICKER_DATE_FORMAT,
  DATE_PICKER_TIME_FORMAT,
  DATE_FORMAT,
  sex,
  indigenousStatus,
  roles,
  idChar,
  codeChar,
  yearDropdownItemNumber,
  modalEffect,
  templateTaskLockedTooltip,
  status,
  appointmentType,
  appointmentStatus,
  timeFrame,
  taskTypes,
  providerTypes,
  firebaseFunctionsUrl,
  marketplaceBaseUrl,
  RECAPTCHA_SITE_KEY,
  directoryEmbedBaseUrl,
  // firebaseFunctionsLocalUrl,
  followUpList,
  meetingTypeList,
  periodList,
  trackingTypeList,
  trackingTypeListAll,
  measurements,
  alertForList,
  taskState,
  conditionExist,
  DURATION_TIME_FORMAT,
  teamMemberType,
  teamStatus,
  alertCount,
  trackingTypes,
  subscriptionPlan,
  localUrl,
  // serverUrl,
  ALGOLIA_APPID,
  ALGOLIA_ADMIN_KEY,
  ALGOLIA_SEARCH_KEY,
  uploadedByType,
  mediaType,
  shortDateFormat,
  DATE_FORMAT_VIEW,
  clinicianType,
  documentType,
  medicationRoutesList,
  medicationUnitList,
  DATE_FORMAT_NEW,
  DATE_PICKER_DATE_FORMAT_NEW,
  indentificationType,
  frequencyPeriodList,
  bpFrequencyList,
  followUpTimeFrameList,
  timeUnit,
  DOCUMENT_EDITING_ALLOWED_FILE_EXTENTIONS,
  taskTypesOptions,
  TASK_TYPE_HELP,
  sensitibityList,
  ranges,
  measurementScaleList,
  selfReportHelperText,
  selfReportAlertOptions,
  APP_VERSION,
  APP_BUILD_DATE
};
